import constants from '../helpers/constants';

const MOBILE_SUBMENU = {
    col: '.js-submenu-col',
    tab: '.js-submenu-tab',
    activeClass: 'is-active',
};

/**
 * покажет Submenu колонку по data-id у таба
 * @param tab {HTMLElement}
 */
function showColumn(tab) {
    const { id } = tab.dataset;

    if (!id) return false;

    const column = document.getElementById(id);

    column.style.display = 'block';
}

/**
 * скроет/отобразит все Submenu колонки в ТГ
 */
function toggleAllColumn(show) {
    const columns = document.querySelectorAll(MOBILE_SUBMENU.col);
    let classProperty = 'none';
    if (show) {
        classProperty = 'flex';
    }
    columns.forEach((col) => {
        col.style.display = classProperty;
    });
}

/**
 * удалит активный класс у всех табов
 */
function removeAllActiveTabClass() {
    const tabs = document.querySelectorAll(MOBILE_SUBMENU.tab);

    tabs.forEach((tab) => {
        tab.classList.remove(MOBILE_SUBMENU.activeClass);
    });
}

/**
 * Обработка клика по табу
 * @param e {Event}
 */
function handlerClickTab(e) {
    const tab = e.currentTarget;
    toggleAllColumn();
    removeAllActiveTabClass();
    tab.classList.add(MOBILE_SUBMENU.activeClass);
    showColumn(tab);
}

/**
 * submenu на мобилке в ТГ
 * @returns {boolean}
 */
function subMobileMenu() {
    const tabs = document.querySelectorAll(MOBILE_SUBMENU.tab);

    if (!tabs.length) return false;

    if (window.innerWidth < constants.desktopWidth) {
        toggleAllColumn();
        tabs.forEach((tab) => {
            tab.addEventListener('click', handlerClickTab);

            if (tab.classList.contains(MOBILE_SUBMENU.activeClass)) {
                showColumn(tab);
            }
        });
    } else {
        toggleAllColumn(true);
    }
}

export default subMobileMenu;
